// extracted by mini-css-extract-plugin
export default {"multiselect":"Multiselect_multiselect__5tI4p"};